import { useEffect } from 'react';
export function useResizeObserver(ref, 
// note: you'll want to memoize this function or the listener will rebind each render
onResize) {
    var observable = ref.current;
    useEffect(function () {
        if (!ref.current) {
            return;
        }
        var observer = new ResizeObserver(function (entries, ob) {
            return requestAnimationFrame(function () { return onResize(entries, ob); });
        });
        observer.observe(ref.current);
        return function () { return observer.disconnect(); };
    }, [onResize, observable, ref]);
}
//# sourceMappingURL=useResizeObserver.js.map